/** Third party packages imports */
// Dayjs imports
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import '@superops/superops-login/dist/styles.css';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isoWeek from 'dayjs/plugin/isoWeek';
import TFAContainer from '@nile/banyan/src/Containers/PageContainers/TFAContainer';
import SignupContainer from '@nile/banyan/src/Containers/SignupContainer';
import { GET_PRIMARY_COMPANY } from '@nile/banyan/src/Graphql/Mutations/msp';
import { connectSocket } from '@nile/home/public/workers/socketConnection';
import ConfirmPage from '@nile/banyan/src/Pages/Public/ConfirmPage';
import PrivateRoute from '@nile/banyan/src/Security/PrivateRoute';
import PublicRoute from '@nile/banyan/src/Security/PublicRoute';
import SystemTrayRoute from '@nile/banyan/src/Security/SystemTrayRoute';
import InvoiceTemplate from '@nile/client_management/src/Pages/Protected/InvoiceTemplate';
import PayInvoice from '@nile/client_management/src/Pages/Protected/PayInvoice';
import QuoteTemplate from '@nile/client_management/src/Pages/Protected/QuoteTemplate';
import InvoicePrint from '@nile/client_management/src/Pages/Protected/InvoicePrint';
import QuotePrint from '@nile/client_management/src/Pages/Protected/QuotePrint';
import CSATPage from '@nile/client_management/src/Pages/Protected/CSATPage';
import TvDashboardView from '@nile/reports/src/modules/reports/components/pages/TvDashboard/index';
import ArticlePublicPage from '@nile/rmm/src/modules/knowledge-base/subpages/public-page';
import {
  intercomInsert,
  initSentry,
  initChameleon,
  loadBeamer,
  initMixpanel
} from '@nile/home/src/thirdPartyIntegrationAuth';
import {
  AppContext,
  PlainLayout,
  ApplicationLayout,
  AppLoader,
  CreateNewPasswordPage,
  SystemTrayNewTicketPage,
  SystemTrayChatPage,
  ChatPromptModal,
  ErrorPages,
  ForgotPasswordPage,
  isAuthorised,
  ExportsPage,
  LoginPage,
  PageLayout,
  NewPricingPage,
  ResetPasswordPage,
  SignupPage,
  TFAPage,
  UpdatePasswordPage,
  setFaviconAndAppTitle,
  PDFPage,
  ShowErrorPage,
  getBrandingLogoAndName,
  EventEmitter,
  EventEmitterWithIndex,
  getHeaderValue,
  sendMessageToContentJS,
  getBrowserType,
  fetchApi,
  COMMON_CONSTANTS,
  getPortalCustomDomain,
  getPortalCustomSubDomain,
  LoginPageIdp,
  FEATURE_GATING_STATUS
} from '@nile/components';
import ErrorPage from '@nile/components/src/Components/ErrorPage';
import ModalWrapper from '@nile/components/src/Modals/modalWrapper';
import {
  AccountClient,
  GET_PERSONALIZATION_BY_NAME,
  GET_CURRENT_USER,
  GET_LOGIN_CONTEXT_USER,
  GET_THIRD_PARTY_KEY,
  GET_INTEGRATIONS_BY_IDS,
  GET_CUSTOMER_LICENSE_EXCEEDED_DETAILS,
  GET_COMPANY_INFO,
  NonAuthAccountClient,
  getNonAuthToken,
  GET_PLAN_FEATURE,
  getPersonalization,
  GET_PLAN_PRODUCT_FEATURES,
  GET_PLAN_FEATURE_GATING,
  GET_USERTERMINAL_WSSTOKEN,
  GET_API_TOKEN,
  GENERATE_API_TOKEN,
  GET_NON_AUTH_LANGUAGE,
  HAS_NYLAS_MAILBOX
} from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import AppHomePage from '@nile/mangifera/src/Pages/AppHomePage';
import ClientHomePage from '@nile/mangifera/src/Pages/ClientHomePage';
import ApprovalTemplate from '@nile/mangifera/src/Pages/Protected/ApprovalTemplate';
import TaskViewPage from '@nile/mangifera/src/Pages/Protected/TaskViewPage';
import ViewIndexPage from '@nile/mangifera/src/Pages/Protected/Ticket/ViewIndexPage';
import Auth from 'Auth/Auth';
import { isEmpty } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import AssetTerminalPage from '@nile/rmm/src/modules/asset-management/components/pages/asset-details-toolbar/Terminal/asset-remote-terminal-page';
import EmailContentSync from '@nile/client_management/src/Containers/EmailContentSync';
import { IntlProvider } from 'react-intl';
import 'react-quill/dist/quill.snow.css'; // ES6
import {
  HashRouter as Router,
  Redirect,
  Route,
  Switch,
  withRouter
} from 'react-router-dom';
import { useQuery } from '@apollo/client';
import './animation.css';
import './App.css';
import { createGlobalStyle } from 'styled-components';
import { LanguageList } from '@nile/banyan/src/Components/Menus/LanguagesList';
import * as _ from 'lodash';
import '@nile/components/src/Utils/XhrErrorHandler'; // Xhr request error handling
import { useFlags, withLDProvider } from 'launchdarkly-react-client-sdk';
import {
  enable as enableDarkReader,
  disable as disableDarkReader,
  setFetchMethod as setFetch,
  exportGeneratedCSS as collectCSS
} from 'darkreader';
import { changePrimaryTheme, setStyle } from './Config/theme';
import { GET_AI_FEATURES } from '@nile/banyan/src/Graphql/Query/ai';
import { useGlobalState } from '@nile/components/src/Managers/StateManager';
import AIFeaturesHook from '@nile/components/src/Utils/aiFeaturesHook';
import { PromptModal } from '@nile/components';
import { LOAD_RMM_APP_PROPERTIES } from '@nile/banyan/src/Graphql/Query/patch';
import { RMMClient } from '@nile/graphql';
import { AIPersonalisationHook } from '@nile/components/src/Components/AI';
import { useHistoricPatchStore } from '@nile/rmm/src/stores/historicPatchStore';
import { useRemoteEnableStore } from '@nile/rmm/src/stores/remoteEnableStore';
import {
  IS_SYSTEMTRAY_ROUTE,
  SOURCE
} from '@nile/components/src/Pages/SystemTrayChatPage/constants';
import ConnectionCheckerContainer from '@nile/home/src/ConnectionCheckerContainer';
import { TicketClient } from '@nile/graphql';
import { GET_CALENDAR_INFO } from '@nile/graphql';
import { CALENDAR_INTEGRATION_ID } from '@nile/mangifera/src/Pages/SchedulingPage/helpers';
import ConversationTemplate from '@nile/mangifera/src/Pages/Conversation/ConversationTemplate';
import { generateString } from '@nile/components';
import SharedReport from '@nile/reports/src/modules/reports/components/pages/SharedReport';
import {
  getAiCommunityBmKey,
  getBaseUrl,
  getCustomSubDomain
} from '@nile/components/src/Utils/helpers';
import { useMDMConfigurations, useMDMClientConfig } from '@nile/mdm';

/** temp fix  */

window.state = {
  terminalSessions: [],
  websocketurl: envConfig.websocketURL
};

Array.prototype.remove = function() {
  // eslint-disable-next-line
  var what,
    a = arguments,
    L = a.length,
    ax;
  while (L && this.length) {
    what = a[--L];
    while ((ax = this.indexOf(what)) !== -1) {
      this.splice(ax, 1);
    }
  }
  return this;
};

function SignupPageComponent() {
  return (
    <SignupPage
      conf={envConfig}
      container={<SignupContainer client={AccountClient} />}
    />
  );
}
function VendorLoginPageComponent() {
  return <LoginPage conf={envConfig} loginType="vendor" screen="login" />;
}
function TFAConfigPageComponent() {
  return <LoginPage conf={envConfig} loginType="vendor" screen="tfaconfig" />;
}

function NewTicketComponent(props) {
  return <SystemTrayNewTicketPage {...props} />;
}

function SystemTrayChatComponent(props) {
  return <SystemTrayChatPage {...props} source={SOURCE.AGENT} />;
}
function SystemChatFrameComponent(props) {
  return <SystemTrayChatPage {...props} source={SOURCE.AGENT} version="NEW" />;
}

function SystemTrayChatPromptComponent(props) {
  return <ChatPromptModal {...props} />;
}

function LoginPageComponent(props) {
  return <LoginPageIdp {...props} />;
}

function LoginPageOldComponent(props) {
  return <ModalWrapper loginPage container={<LoginPage />} />;
}
function SupportAccessL2() {
  return (
    <ModalWrapper
      idpFlow
      loginPage
      container={<LoginPage screen="support" />}
    />
  );
}

function ForgotPasswordPageComponent() {
  return (
    <ModalWrapper
      idpFlow
      title="product.userLogin.forgotPassword.label"
      container={<ForgotPasswordPage />}
    />
  );
}

function showErrorPage() {
  return <ShowErrorPage />;
}

function CreateNewPasswordPageComponent() {
  return <CreateNewPasswordPage />;
}

function ResetPasswordPageComponent() {
  return <ResetPasswordPage />;
}

function TFAPageComponent() {
  return <TFAPage />;
}

function UpdatePasswordPageComponent() {
  return <UpdatePasswordPage />;
}

/* mspinformation has been added as landing page for this application */

const GlobalStyles = createGlobalStyle`
  .Toastify__toast-container--bottom-right {
    left: calc(100% - ${(props) =>
      props.intercomEnabled ? '650px' : '550px'}) !important;
    bottom: 0 !important;
    transform: none !important;

    .Toastify__toast {
      margin-bottom: 0;
    }
  }
`;

const defaultLangCode = {
  value: 'en',
  label: 'English',
  code: 'en',
  nativeName: 'English'
};

function App(props) {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  const [userError, setUserError] = useState(null);
  const [thirdPartyKey, setThirdPartyKey] = useState(null);
  const [stripeAccountId, setStripeAccountId] = useState(null);
  const [tablePersonalization, setTablePersonalization] = useState(null);
  const [isSuperopsUser, setisSuperopsUser] = useState(null);
  const [isTrialUser, setIsTrialUser] = useState(true);
  const tablePersonalizationByRef = React.useRef(null);
  tablePersonalizationByRef.current = tablePersonalization;

  const [selectedLangCode, setSelectedLangCode] = useState(null);
  const [profileLanguage, setProfileLanguage] = useState(null);
  const [languageData, setLanguageData] = useState(null);
  const [customerLicense, setCustomerLicense] = useState(null);
  const [isIntercomVisible, setIntercomVisible] = useState(false);
  const [companyInfo, setCompanyInfo] = useState(null);
  const [darkTheme, setDarkTheme] = useState(false);
  const [planFeatureList, setPlanFeatureList] = useState(null);
  const [conversationOrder, setConversationOrder] = useState('ASC');
  const [rmmProperties, setRmmProperties] = useState({});
  const [appViewPersonalization, setAppViewPersonalization] = useState(null);

  // Initialize historic patch store (using selector to prevent unnecessary re-renders)
  const initializeFromAppContext = useHistoricPatchStore(
    (state) => state.initializeFromAppContext
  );
  // Initialize remote enable store from app personalization
  const initializeRemoteFromAppContext = useRemoteEnableStore(
    (state) => state.initializeFromAppContext
  );

  const windowId = React.useRef(null);

  const { maintenance: underMaintenancePage = null } =
    JSON.parse(localStorage.getItem('previousRoute')) || {};

  // for extension use
  const getAuthorizationToken = async () => {
    const requestOptions = {
      method: 'GET',
      credentials: 'include',
      headers: getHeaderValue()
    };
    const response = await fetchApi(
      `${envConfig.loginRoot}/user/authorizationtoken`,
      requestOptions
    );

    const datax = await response.json();

    const authorizationtoken = datax.authorizationToken;

    if (authorizationtoken) {
      localStorage.setItem('authorizationtoken', authorizationtoken);
      sendMessageToContentJS('authToken');
    } else {
      console.log('no authorizationtoken');
      // dispatch token either way if no data sent this domain will be focused.
      sendMessageToContentJS('authToken');
    }
  };

  const getLanguageObjectSet = (langCode = 'en') => {
    const options = LanguageList;
    return options.find((l) => l.code === langCode) || options[0];
  };

  const getDarkTheme = (currUser) => {
    getPersonalization({
      userId: currUser?.userId,
      name: 'Theme',
      category: 'ThemePersonalization'
    })
      .then((response) => {
        if (response) {
          const res = response?.data?.getPersonalizationByCategoryAndName;
          if (res !== null) {
            setDarkTheme(JSON.parse(res?.value)?.darkTheme);
          } else {
            setDarkTheme(false);
          }
        }
      })
      .catch((err) => {});
  };
  function getCurrentAccountType(currentUserData, currentRoleType) {
    const { accountType, associations } = currentUserData;
    const { companyOrg, clientOrg } = associations[0]?.org || {};

    // for IT, requester space, redirect to client portal
    if (companyOrg && clientOrg) {
      return currentRoleType === COMMON_CONSTANTS.REQUESTER ? 'CLIENT' : 'MSP';
    }

    if (clientOrg) {
      return 'CLIENT';
    }

    if (companyOrg) {
      return 'MSP';
    }

    return 'MSP';
  }
  function returnContextData(currentContext, currentRoleType) {
    /** Current configured role returned from localstorage */
    const currentRole =
      currentContext?.user?.roles?.find(
        (r) => r.roleType.type === currentRoleType
      ) || null;
    return {
      ...currentContext,
      //We are spreading the object is to meet the existing behaviour after back-end changing the JSON structure.
      //New changes from here on has to be taken from the currentContext object only.

      /** DO NOT CHANGE THIS ORDER */
      ...currentContext?.user,
      ...currentContext?.customer,
      ...currentContext?.hqSiteContext,
      ...currentContext?.organizationContext,
      ...currentContext?.subscriptionContext,
      name: currentContext?.user?.name,
      accountType: getCurrentAccountType(currentContext?.user, currentRoleType),
      //TODO ITSM
      role: currentRole || currentContext?.user.roles[0],
      domain:
        getPortalCustomSubDomain(
          currentContext?.organizationContext?.portalDomains
        )?.domainName + `.${currentContext?.organizationContext?.baseDomain}` ??
        ''
    };
  }
  function getCurrentRoleType(currentContext, currentServicePortalValue) {
    if (currentServicePortalValue) {
      return currentServicePortalValue;
    }
    const currentRoles = currentContext?.user?.roles;
    const ifOnlyOneRoleAssigned = currentRoles?.length === 1;
    if (ifOnlyOneRoleAssigned) {
      return currentRoles?.[0]?.roleType?.type;
    }
    return COMMON_CONSTANTS.TECHNICIAN;
  }

  async function getCurrentServicePortalValue(currentContext) {
    try {
      const currentWorkSpace = await getPersonalization({
        userId: currentContext?.user?.userId,
        name: 'CurrentServicePortal',
        category: 'currentServicePortalPersonalization'
      });
      return currentWorkSpace;
    } catch (ex) {
      console.error('Failed to get current portal value ');
      return null;
    }
  }

  const getLoginContextData = async () => {
    const response = await AccountClient.query({
      query: GET_LOGIN_CONTEXT_USER,
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE
    });
    const currentContext = response?.data?.getLoggedInContext;
    setCompanyInfo(resolveCompanyData(currentContext));

    const currentWorkSpace = await getCurrentServicePortalValue(currentContext);
    const currentServicePortalValue =
      currentWorkSpace?.data?.getPersonalizationByCategoryAndName?.value ||
      null;
    const currentRoleType = getCurrentRoleType(
      currentContext,
      currentServicePortalValue
    );
    localStorage.setItem(
      'currentServicePortal',
      currentRoleType || COMMON_CONSTANTS.TECHNICIAN
    ); // fallback to technician
    return returnContextData(currentContext, currentRoleType);
  };

  const getUser = async () => {
    const contextData = await getLoginContextData()
      .then((userDetails) => {
        if (userDetails) {
          setUser(userDetails);
          setUserError(null);
          setisSuperopsUser(
            userDetails?.customer?.source?.name === 'SUPEROPS' ||
              userDetails?.customer?.source === null
          );
          setIsTrialUser(
            userDetails?.subscriptionStatus === 'TRIAL' ||
              userDetails?.subscriptionStatus === 'TRIAL_EXPIRED'
          );
          if (userDetails?.userId) getDarkTheme(userDetails);
          localStorage.setItem('currentUser', JSON.stringify(userDetails));
          window.postMessage(`dispatchCurrentUserEvent from nile!`);
          return userDetails;
        }
      })
      .catch((err) => {
        console.log(err, 'error on get user');
        setUser({});
        // setUserError(err);
      });

    return contextData;
  };

  const getFeaturesGating = async () => {
    const response = await AccountClient.query({
      query: GET_PLAN_FEATURE_GATING,
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE
    })
      .then((res) => {
        if (res?.data) {
          setPlanFeatureList(res?.data.getFeatureGatingInfo);
        }
      })
      .catch((err) => console.log(err));
    return response;
  };

  //used here for listing "patchoverride" feature in settings list based on advance hierarchy.
  const getRMMAppProperties = async () => {
    const response = await RMMClient.query({
      query: LOAD_RMM_APP_PROPERTIES,
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE
    })
      .then((res) => {
        if (res?.data) {
          setRmmProperties(res?.data?.loadRMMAppProperties);
        }
      })
      .catch((err) => console.log(err));
    return response;
  };

  const getCompanyDetails = () => {
    try {
      return AccountClient.query({
        query: GET_PRIMARY_COMPANY,
        fetchPolicy: 'no-cache'
      });
    } catch (err) {}
  };

  //Adding this resolver to meet the existing changes on company JSON after Back-end changing the JSON structure.
  const resolveCompanyData = (currentContext) => {
    return {
      ...currentContext.organizationContext,
      ...currentContext.hqSiteContext,
      customDomain:
        getPortalCustomDomain(currentContext.organizationContext?.portalDomains)
          ?.domainName ?? '',
      portalDomain:
        getPortalCustomSubDomain(
          currentContext.organizationContext?.portalDomains
        )?.domainName + `.${currentContext.organizationContext?.baseDomain}` ??
        ''
    };
  };

  const getNonAuthCompanyInfo = async (AuthClientType) => {
    try {
      const response = await AuthClientType.query({
        query: GET_NON_AUTH_LANGUAGE,
        fetchPolicy: 'network-only'
      });
      setCompanyInfo(resolveCompanyData(response?.data?.getLoggedInContext));
      return response?.data?.getLoggedInContext?.organizationContext;
    } catch (err) {}
  };

  const getUserPersonalisation = async (
    currUser,
    isCompanyLanguageAvailable
  ) => {
    await AccountClient.query({
      query: GET_PERSONALIZATION_BY_NAME,
      variables: {
        userId: currUser?.userId,
        category: 'AppViewPersonalization',
        name: currUser?.userId
      },
      fetchPolicy: 'network-only'
    })
      .then((res) => {
        const personalization = res?.data?.getPersonalizationByCategoryAndName;
        if (personalization) {
          const saved = JSON.parse(personalization.value);
          setAppViewPersonalization(saved);
          // Initialize historic patch store from appViewPersonalization
          initializeFromAppContext(saved);
          // Initialize remote enable store from appViewPersonalization.remotePopupState
          initializeRemoteFromAppContext(saved?.remotePopupState || null);
          if (saved && Object.keys(saved).length && saved?.lang?.code) {
            setSelectedLangCode(saved.lang);
            setProfileLanguage(saved.lang);
          } else {
            setSelectedLangCode(isCompanyLanguageAvailable);
          }
        } else {
          setSelectedLangCode(isCompanyLanguageAvailable);
        }
      })
      .catch((err) => {
        setSelectedLangCode(isCompanyLanguageAvailable);
      });
  };

  const getCustomerLicense = async () => {
    const response = await AccountClient.query({
      query: GET_CUSTOMER_LICENSE_EXCEEDED_DETAILS,
      fetchPolicy: 'network-only'
    })
      .then((res) => {
        setCustomerLicense(res);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    const browserType = getBrowserType();
    if (darkTheme && browserType !== 'Apple Safari') {
      // setFetch(window.fetch);
      enableDarkReader(
        {
          brightness: 100,
          contrast: 100,
          sepia: 1
        },
        {
          css:
            '.commandbar-popover-container,.commandbar-opened { border: 2px solid #2a2a2a; }',
          invert: [
            '.ql-toolbar *[type="button"]',
            '.activity-icon-parent > img',
            '[class*="commandbar-toplevel-"] * > button',
            '[class*="commandbar-toplevel-"] * > span'
          ],
          ignoreInlineStyle: [
            '.ignoreOverride > svg *',
            '[class*="commandbar-toplevel-"] > svg *',
            '.commandbar-option > div > svg *',
            '.ignoreOverride *',
            '[class*="ignoreOverride"]',
            '[class*="commandbar-ask-with-ai-btn-wrapper"] *',
            '.tiptap_editor *'
          ],
          ignoreImageAnalysis: ['*'],
          disableStyleSheetsProxy: true
        }
      );
    } else {
      disableDarkReader();
    }
  }, [darkTheme]);

  const setCookie = (subDomain) => {
    const currentCookies = document.cookie;
    document.cookie = `CustomerSubDomain=${subDomain};domain=localhost;path=/; `.concat(
      currentCookies
    );
  };

  const getCookieValue = (name) => {
    return document.cookie
      .match(RegExp(name + '=.[^;]*'))
      ?.pop()
      ?.replace(`${name}=`, '');
  };

  const getMarketplaceCookie = async (currUser) => {
    const marketplaceToken = getCookieValue('so-marketplace-session') || '';
    if (currUser?.idpSubjectIdentifier && !marketplaceToken) {
      try {
        // First, get the idToken from the authorization endpoint
        const myHeaders = new Headers();

        const requestOptions = {
          method: 'GET',
          headers: myHeaders,
          redirect: 'follow',
          credentials: 'include'
        };
        const authResponse = await fetch(
          `${localStorage.getItem(
            'apiDomain'
          )}/accounts-web/authorize/idp/token?clientId=marketplace`,
          requestOptions
        );
        const authData = await authResponse.json();
        const idToken = authData?.idToken;

        if (!idToken) {
          console.error('Failed to get idToken from authorization endpoint');
          return;
        }

        const queryParams = new URLSearchParams();

        // Add the idToken parameter
        queryParams.append('idToken', idToken);

        if (envConfig.mode === 'development') {
          // email=dhinesh.l@superops.com&soCustomerDomain=test.superopsalpha.com&appState=test&deviceType=WEB&display=PAGE&state=test
          queryParams.append('email', currUser?.email || '');
          queryParams.append(
            'soCustomerDomain',
            `${getCustomSubDomain()}.superopsalpha.com` || ''
          );
          queryParams.append('deviceType', 'WEB');
        }

        // Create an iframe to handle the silent call
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.style.width = '0';
        iframe.style.height = '0';

        // Append iframe to body and set the source
        document.body.appendChild(iframe);
        const authUrl = `${getBaseUrl(
          false,
          false,
          true
        )}/marketplace/api/authorize/silent?${queryParams.toString()}`;
        iframe.src = authUrl;
      } catch (error) {
        console.error('Error fetching idToken:', error);
      }
    }
  };

  const getDetails = async () => {
    const currUser = await getUser();
    sendMessageToContentJS('currentUser');
    // Set language based on TFA forced configured case
    if (isEmpty(selectedLangCode) && isEmpty(currUser)) {
      setSelectedLangCode(defaultLangCode);
    }

    let isCompanyLanguageAvailable = '';
    try {
      const reference = currUser?.role?.roleFeatureList || [];
      const isCompanyAuthorised = isAuthorised(
        reference,
        'mspInformation.view'
      );
      if (isCompanyAuthorised) {
        try {
          const res = await getCompanyDetails();
          const companyData = res.data?.getPrimaryCompany;
          if (companyData) {
            setCompany({
              ...companyData?.details,
              ...companyData?.hqSite,
              ...companyData?.hqSite?.address,
              ...companyData
            });
            const companyLanguageSet = getLanguageObjectSet(
              companyData.details?.language
            );
            isCompanyLanguageAvailable = companyLanguageSet;
          }
        } catch (err) {}
      }
    } catch (err) {}

    const language = currUser?.language || currUser?.companyInfo?.language;
    if (language && !isCompanyLanguageAvailable) {
      const nonAuthcompanyLanguageSet = getLanguageObjectSet(language);
      isCompanyLanguageAvailable = nonAuthcompanyLanguageSet;
    }
    if (!isCompanyLanguageAvailable) {
      isCompanyLanguageAvailable = {
        value: 'en',
        label: 'English',
        code: 'en',
        nativeName: 'English'
      };
    }
    if (currUser?.userId) {
      await getUserPersonalisation(currUser, isCompanyLanguageAvailable);
      await getMarketplaceCookie(currUser);
    } else {
      setSelectedLangCode(isCompanyLanguageAvailable);
    }
  };

  const getThirdPartyHashKey = async () => {
    const response = await AccountClient.query({
      query: GET_THIRD_PARTY_KEY,
      fetchPolicy: 'network-only'
    })
      .then((res) => {
        if (res?.data?.getCurrentUserThirdPartyHashKey) {
          setThirdPartyKey(res.data);
          return res.data;
        }
      })
      .catch((err) => {
        setThirdPartyKey(null);
      })
      .finally(() => {});
    return response;
  };

  const getTablePersonalisation = async () => {
    const currentUser = await getUser();
    AccountClient.query({
      query: GET_PERSONALIZATION_BY_NAME,
      variables: {
        userId: currentUser?.userId,
        category: 'tableViewPersonalization',
        name: currentUser?.userId
      },
      fetchPolicy: 'network-only'
    })
      .then((res) => {
        const personalization = res?.data?.getPersonalizationByCategoryAndName;
        if (personalization) {
          setTablePersonalization(personalization);
        }
      })
      .catch((err) => {});
  };

  const getConversationPersonalisation = async () => {
    const currentUser = await getUser();
    AccountClient.query({
      query: GET_PERSONALIZATION_BY_NAME,
      variables: {
        userId: currentUser?.userId,
        category: 'conversation-order',
        name: currentUser?.userId
      },
      fetchPolicy: 'network-only'
    })
      .then((res) => {
        const personalization = res?.data?.getPersonalizationByCategoryAndName;
        if (personalization) {
          const value =
            personalization?.value && JSON.parse(personalization?.value);
          const order = value?.conversationOrder || 'ASC';
          setConversationOrder(order);
        }
      })
      .catch((err) => {});
  };

  const setNonAuthCompanyLanguage = async () => {
    const nonAuthLanguage = await getNonAuthCompanyInfo(NonAuthAccountClient);
    if (nonAuthLanguage?.language) {
      const nonAuthcompanyLanguageSet = getLanguageObjectSet(
        nonAuthLanguage?.language
      );
      setSelectedLangCode(nonAuthcompanyLanguageSet);
    } else {
      setSelectedLangCode(defaultLangCode);
    }
  };

  function loggedInUserAPIs() {
    Promise.all([
      getDetails(),
      getThirdPartyHashKey(),
      getAiCommunityBmKey(),
      getTablePersonalisation(),
      getCustomerLicense(),
      getFeaturesGating(),
      getConversationPersonalisation(),
      getRMMAppProperties()
    ]);
  }

  const setThemeCustomization = () => {
    const haveThemeValues = localStorage.getItem(
      `${window.location.host}-config`
    );

    if (haveThemeValues) {
      const themeValues = JSON.parse(haveThemeValues);
      const themeOptions = changePrimaryTheme(
        themeValues.bgColor,
        themeValues.textColor
      );
      setStyle(themeOptions);
    }
  };
  const getNonAuthMSPLanguage = async () => {
    const { language: nonAuthLanguage } = await getBrandingLogoAndName();
    // nonAuthLanguage values enum- ["en","de","fr_CA"] etc
    // incase the MSP language is not available, set the default language
    const languageCodeToSet = {
      code: nonAuthLanguage || defaultLangCode?.code,
      id: nonAuthLanguage || defaultLangCode?.id,
      label: nonAuthLanguage || defaultLangCode?.label
    };
    setSelectedLangCode(languageCodeToSet);
  };

  /**
   * Method to extend dayjs plugin globally for all js
   */
  const setupDayjsWithPlugins = () => {
    dayjs.extend(isSameOrBefore);
    dayjs.extend(isoWeek);
    dayjs.extend(utc);
    dayjs.extend(timezone);
  };

  const checkForInitialParams = () => {
    const hash = window.location.hash;
    const match = hash.match(/#\/\?(.*)/);
    if (match?.[1]) {
      const params = match?.[1];
      sessionStorage.setItem('redirectUrlParams', params);
    }
  };

  useEffect(() => {
    checkForInitialParams();
    if (Auth.isAuthenticated) {
      // for extension use
      getAuthorizationToken();

      // Custom theme personalisation
      setThemeCustomization();

      loggedInUserAPIs();
      if (window.Chargebee) {
        window.Chargebee.init({
          site: envConfig.chargeBeeEnv
        });
      }
      // Set customize fav icon
      setFaviconAndAppTitle();
    } else {
      const params = new URLSearchParams(window.location.hash);
      const token = params.get('token');
      if (token && !isEmpty(token)) {
        setNonAuthCompanyLanguage();
      } else {
        // login, page not found or forgot password page
        getNonAuthMSPLanguage();
      }
    }
    const tenid = document.cookie.match(/uitoken\=([^;]*)/)
      ? document.cookie.match(/uitoken\=([^;]*)/)[0]?.split('=')[1]
      : '-1';

    if (
      envConfig.mode !== 'development' &&
      window.location.hostname.split('.').length > 2
    ) {
      setCookie(window.location.hostname.split('.')[0]);
    }
    if (envConfig.mode === 'development') {
      setCookie('dev');
    }
    const initialMemoryUsage = performance?.memory?.usedJSHeapSize;
    console.log('initial memory usage', initialMemoryUsage);

    // Dayjs plugin initialization globally
    setupDayjsWithPlugins();
    if (!windowId?.current) {
      const currentWindowId = generateString(8);
      windowId.current = currentWindowId;
      sessionStorage.setItem('windowId', currentWindowId);
    }
  }, []);

  function hideIntercom() {
    document.getElementsByClassName(
      'intercom-lightweight-app'
    )[0].style.visibility = 'hidden';
  }

  useEffect(() => {
    if (!isEmpty(user) && !isEmpty(thirdPartyKey) && !isEmpty(companyInfo)) {
      if (
        // envConfig.mode !== 'development' &&
        user?.accountType === 'MSP'
      ) {
        // Intercom init
        if (thirdPartyKey) {
          intercomInsert(
            user,
            thirdPartyKey,
            company,
            companyInfo,
            props?.currentProduct || 'MSP'
          ); // auth intercom
        }

        if (
          user.chargeBeePlanId === 'solo' &&
          document.getElementsByClassName('intercom-lightweight-app')?.[0]
        ) {
          hideIntercom();
        }
      }
      if (
        document.getElementsByClassName(
          'intercom-lightweight-app-launcher'
        )?.[0]
      ) {
        setIntercomVisible(true);
      }
    }
    if (!isEmpty(user)) {
      const integrationConfig = {
        user,
        thirdPartyKey,
        company,
        companyInfo,
        currentProduct: props?.currentProduct || 'MSP'
      };

      initChameleon(integrationConfig);
      loadBeamer(integrationConfig);

      if (
        (localStorage.getItem('feedback') == null ||
          localStorage.getItem('feedback')?.length === 0) &&
        thirdPartyKey
      ) {
        if (isEmpty(thirdPartyKey)) {
          localStorage.setItem(
            'feedback',
            thirdPartyKey.getCurrentUserThirdPartyHashKey['cy-key']
          );
        }
      }
      if (
        thirdPartyKey &&
        (localStorage.getItem('bm-key') == null ||
          localStorage.getItem('bm-key') !=
            thirdPartyKey?.getCurrentUserThirdPartyHashKey['bm-key'])
      ) {
        localStorage.setItem(
          'bm-key',
          thirdPartyKey.getCurrentUserThirdPartyHashKey['bm-key']
        );
      }

      /* Mixpanel initialization */
      const mixpanelConfig = {
        user: user,
        currentProduct: props?.currentProduct || 'MSP'
      };
      initMixpanel(mixpanelConfig);
      /* Mixpanel initialization */
    }
  }, [user, company, companyInfo]);

  const changeSelectedLang = (lang) => {
    setSelectedLangCode(lang);
  };

  async function load(url) {
    try {
      const response = await fetch(url, {
        method: 'GET'
      });

      // Since the server intentionally doesn't allow CORS, it will result in an error
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      setLanguageData(data);
      window.TranslationMessages = data;
    } catch (error) {
      console.error('Fetch error:', error);
    }

    // set loading to false, only after the lokalise json is downloaded (prevent keys getting exposed on page load)
    setUserLoading(false);
  }
  const getLanguageData = () => {
    const baseURL = envConfig.public;
    const currentCode = isEmpty(selectedLangCode?.code)
      ? defaultLangCode?.code
      : selectedLangCode?.code;
    const url = `${baseURL}/intl/locale/${currentCode}.json?id=g-${new Date().getTime()}`;
    //const url = `${baseURL}/intl/${currentCode}/no_filename.json?id=g-${new Date().getTime()}`;
    load(url);
  };

  const aiFeatureHook = AIFeaturesHook();
  const aiPersonalisationHook = AIPersonalisationHook();

  const [integratedCalenderData, setIntegratedCalendarData] = useState(null);

  const getIntegratedCalendarData = () => {
    TicketClient.query({
      query: GET_CALENDAR_INFO
    }).then((res) => {
      if (
        res?.data?.getUserCalendarInfo &&
        !isEmpty(res?.data?.getUserCalendarInfo)
      ) {
        let calendarInfo = res?.data?.getUserCalendarInfo;
        const calendarName = calendarInfo?.calendarName;
        const integratedCalendarId =
          CALENDAR_INTEGRATION_ID?.[calendarName] || null;
        setIntegratedCalendarData({
          ...calendarInfo,
          integratedCalendarId: integratedCalendarId
        });
      }
    });
  };

  useEffect(() => {
    const isMSP = user?.accountType === 'MSP';
    if (!isEmpty(user)) {
      if (aiFeatureHook?.getAIFeaturesData) {
        aiFeatureHook?.getAIFeaturesData();
      }

      if (
        isMSP &&
        aiPersonalisationHook?.getAIPersonalisation &&
        !isEmpty(user)
      ) {
        aiPersonalisationHook?.getAIPersonalisation(user);
      }
    }

    if (!isEmpty(user)) {
      // The integrated caelndar id will be retured from here.
      // This ID will be used in calendar widget too.
      getIntegratedCalendarData();
    }
  }, [user]);

  useEffect(() => {
    window.addEventListener('refetchGlobalTimers', () => {
      EventEmitterWithIndex.dispatch('refetchGlobalTimers');
      EventEmitter.dispatch('refetchTimerEntries');
    });
  }, []);

  useEffect(() => {
    if (selectedLangCode) {
      getLanguageData();
    }
  }, [selectedLangCode]);

  const tenid = document.cookie.match(/uitoken\=([^;]*)/)
    ? document.cookie.match(/uitoken\=([^;]*)/)[0]?.split('=')[1]
    : '';
  const hasCsrfCookie = getCookieValue('app-csrf');

  const { data: tokenData } = useQuery(GET_USERTERMINAL_WSSTOKEN, {
    client: AccountClient,
    fetchPolicy: 'network-only',
    skip: tenid?.length === 0 || isEmpty(hasCsrfCookie)
  });

  const skipNylas = () => {
    if (isEmpty(user)) {
      return true;
    }
    return user?.accountType !== 'MSP';
  };

  const { data: hasNylasMailbox } = useQuery(HAS_NYLAS_MAILBOX, {
    client: AccountClient,
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
    skip: skipNylas()
  });

  const mdmFeatureProps = planFeatureList?.MDM;
  const isMdmExpired =
    mdmFeatureProps?.status === FEATURE_GATING_STATUS.EXPIRED;

  const isMSPProduct = props.currentProduct === COMMON_CONSTANTS.MSP;
  const isITProduct = props.currentProduct === COMMON_CONSTANTS.IT;

  const itClientId = isITProduct && user?.associations?.[0]?.org?.accountId;

  const { clientConfig: mdmClientConfigIT } = useMDMClientConfig(
    isITProduct && itClientId ? itClientId : null,
    !(isMdmExpired && isITProduct)
  );

  const { clients: mdmClientsMSP } = useMDMConfigurations({
    currentPage: 1,
    searchCondition: null,
    skip: !(isMdmExpired && isMSPProduct)
  });

  // Calculate banner visibility states (centralized logic from TabsList.js)
  const bannerVisibility = React.useMemo(() => {
    const accountTypeMSP = user?.accountType === 'MSP';

    const hasPaymentDue =
      customerLicense?.data?.getCustomerLicenseExceededDetails
        ?.hasSubscriptionPaymentDue;
    const technicianLicenseCount =
      customerLicense?.data?.getCustomerLicenseExceededDetails
        ?.isTechnicianLicenseCountExceeded;
    const endpointLicenseCount =
      customerLicense?.data?.getCustomerLicenseExceededDetails
        ?.isEndpointLicenseCountExceeded;
    const outboundEmailLicense =
      customerLicense?.data?.getCustomerLicenseExceededDetails
        ?.isOutboundEmailRateLimitExceeded;

    const isPaymentBannerVisible = hasPaymentDue && isMSPProduct;
    const isNylasBannerVisible =
      hasNylasMailbox?.hasNylasMailbox &&
      !hasPaymentDue &&
      !isPaymentBannerVisible;
    const isLicenseBannerVisible =
      (technicianLicenseCount && isMSPProduct) ||
      (endpointLicenseCount && isMSPProduct) ||
      outboundEmailLicense;

    // MDM banner: Show when MDM expired and config is available (data not cleaned)
    let isMdmBannerVisible = false;
    if (
      !isPaymentBannerVisible &&
      !isNylasBannerVisible &&
      !isLicenseBannerVisible &&
      isMdmExpired
    ) {
      if (isITProduct) {
        isMdmBannerVisible = mdmClientConfigIT?.client;
      } else if (isMSPProduct) {
        isMdmBannerVisible = mdmClientsMSP?.length > 0;
      }
    }

    // Check if ANY banner is visible
    const isAnyBannerVisible =
      isNylasBannerVisible ||
      isPaymentBannerVisible ||
      isLicenseBannerVisible ||
      isMdmBannerVisible;

    if (accountTypeMSP) {
      return {
        isNylasBannerVisible,
        isPaymentBannerVisible,
        isLicenseBannerVisible,
        isMdmBannerVisible,
        isAnyBannerVisible
      };
    }

    return {
      isNylasBannerVisible: false,
      isPaymentBannerVisible: false,
      isLicenseBannerVisible: false,
      isMdmBannerVisible: false,
      isAnyBannerVisible: false
    };
  }, [
    customerLicense,
    hasNylasMailbox,
    isMSPProduct,
    isITProduct,
    isMdmExpired,
    mdmClientConfigIT?.client,
    mdmClientsMSP?.length
  ]);

  useEffect(() => {
    if (
      tokenData &&
      tokenData.populateUserTerminalWssToken.length > 0 &&
      user?.accountType === 'MSP' &&
      !IS_SYSTEMTRAY_ROUTE
    ) {
      connectSocket();
    }
  }, [tokenData?.populateUserTerminalWssToken, user?.accountType]);

  useEffect(() => {
    if (underMaintenancePage && userLoading) {
      setSelectedLangCode(defaultLangCode);
      setUserLoading(false);
    }
  }, [underMaintenancePage]);

  if (
    userLoading ||
    (Auth.isAuthenticated && user === null && underMaintenancePage !== true)
  )
    return (
      <div className="vh100 flex center jctr">
        <GlobalStyles />
        <AppLoader showLetNav />
      </div>
    );

  const handleLocaleError = () => {};

  function updateCompanyContext(companyDetails) {
    if (isEmpty(companyDetails)) {
      return;
    }
    setCompany({
      ...companyDetails?.details,
      ...companyDetails?.hqSite,
      ...companyDetails?.hqSite?.address,
      ...companyDetails
    });
    setCompanyInfo((prev) => ({
      ...prev,
      ...companyDetails?.hqSite,
      ...companyDetails?.hqSite?.address,
      ...companyDetails?.details
    }));
    const updatedLanguage = companyDetails.updatedLanguage;
    if (
      updatedLanguage &&
      !profileLanguage &&
      company.language !== companyDetails.updatedLanguage?.code
    ) {
      const languageCodeToSet = {
        code: updatedLanguage.code,
        id: updatedLanguage.id,
        label: updatedLanguage.label
      };
      setSelectedLangCode(languageCodeToSet);
    }
  }

  const updateRmmProperties = (rmmPropertiesDetails) => {
    setRmmProperties((prev) => ({
      ...prev,
      'rmm.policyManagementType':
        rmmPropertiesDetails['rmm.policyManagementType'],
      'rmm.AdvancedHierarchyTransition':
        rmmPropertiesDetails['rmm.AdvancedHierarchyTransition']
    }));
  };

  /*
  Launchdarkly config
  */
  const LDWrappedComponent = withLDProvider({
    clientSideID: envConfig.launchDarklyClientID,
    context: {
      kind: 'user',
      key: user?.customerId,
      plan: user?.chargeBeePlanId,
      domain: user?.domain,
      subscriptionStatus: user?.subscriptionStatus,
      productType: props?.currentProduct || 'MSP'
    },
    reactOptions: {
      sendEventsOnFlagRead: false
    }
  })((props) => (
    <>
      <RouteComponent userError={userError} user={user} {...props} />
      {/* <ConnectionCheckerContainer {...props} /> */}
    </>
  ));
  const currentLang = selectedLangCode ? selectedLangCode : defaultLangCode;

  return (
    <IntlProvider
      onError={handleLocaleError}
      locale={currentLang?.value?.replace(/_/g, '-')}
      messages={languageData}
    >
      <AppContext.Provider
        value={{
          user,
          company,
          updateCompanyContext,
          currentLanguage: currentLang,
          changeSelectedLang,
          getUser,
          accountType: user?.accountType || 'MSP',
          customerLicense,
          languageData,
          tablePersonalization: tablePersonalizationByRef.current,
          setTablePersonalization: setTablePersonalization,
          companyInfo,
          planFeatureList,
          getCustomerLicense,
          thirdPartyKey,
          darkTheme,
          setDarkTheme,
          conversationOrder,
          setConversationOrder,
          isSuperopsUser: isSuperopsUser,
          isTrialUser: isTrialUser,
          rmmProperties,
          updateRmmProperties,
          currentProduct: props.currentProduct || 'MSP', // MSP or IT.-> setting fallback to MSP product
          currentServicePortal: localStorage.getItem('currentServicePortal'),
          integratedCalenderData: integratedCalenderData,
          stripeAccountId,
          setStripeAccountId,
          windowId,
          hasNylasMailbox: hasNylasMailbox?.hasNylasMailbox,
          appViewPersonalization,
          bannerVisibility: bannerVisibility
        }}
      >
        <GlobalStyles intercomEnabled={isIntercomVisible} />
        {
          <>
            <Router className="main" basename={envConfig.base}>
              {user ? (
                <LDWrappedComponent {...props} />
              ) : (
                <RouteComponent userError={userError} user={user} {...props} />
              )}
            </Router>
          </>
        }
      </AppContext.Provider>
    </IntlProvider>
  );
}

const RouteComponent = withRouter((props) => {
  const appContext = useContext(AppContext);

  const { accountType, user } = appContext;
  const flags = useFlags();

  useEffect(() => {
    if (flags.sessionReplay && location.hash.indexOf('debug=true') == -1) {
      location.hash = location.hash + '?debug=true';
    }
    if (!flags.sessionReplay && location.hash.indexOf('debug=true') == -1) {
      location.hash = location.hash.replace('debug=true', '');
    }
  }, [flags.sessionReplay]);

  useEffect(() => {
    if (user && user?.email) {
      initSentry(user, flags);
    }
  }, [flags, user]);

  return (
    <Switch>
      <PublicRoute path="/l2" component={SupportAccessL2} layout={PageLayout} />

      <PrivateRoute
        path="/initiate-remote-session/error"
        component={showErrorPage}
        layout={PageLayout}
      />
      <PublicRoute
        path="/login"
        component={LoginPageComponent}
        layout={PageLayout}
      />
      <PublicRoute
        path="/login/customer"
        component={LoginPageOldComponent}
        layout={PageLayout}
      />
      <SystemTrayRoute
        path="/systray/new-ticket"
        component={NewTicketComponent}
        layout={ApplicationLayout}
      />

      <SystemTrayRoute
        path="/systray/chat"
        component={SystemTrayChatComponent}
        layout={ApplicationLayout}
      />
      <SystemTrayRoute
        path="/systray/frame/chat"
        component={SystemChatFrameComponent}
        layout={ApplicationLayout}
      />

      <SystemTrayRoute
        path="/systray/prompt"
        component={SystemTrayChatPromptComponent}
        layout={ApplicationLayout}
      />

      <PrivateRoute
        path="/sync-email-contents"
        component={EmailContentSync}
        layout={PlainLayout}
      />

      <PrivateRoute
        path="/openterminal/:assetId/:classId/:loginType/:termType"
        component={AssetTerminalPage}
        layout={PlainLayout}
      />

      <PrivateRoute
        path="/product/feedback"
        component={AppHomePage}
        layout={ApplicationLayout}
      />

      <PrivateRoute
        path="/product/forum"
        component={AppHomePage}
        layout={ApplicationLayout}
      />

      <PrivateRoute
        path="/productonboard"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/migrate"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/product/forum"
        component={AppHomePage}
        layout={ApplicationLayout}
      />

      <Route path="/csat-survey" render={(props) => <CSATPage {...props} />} />
      <PrivateRoute
        path="/quote/create"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/quote/export/:id"
        component={PDFPage}
        layout={PlainLayout}
      />
      <Route
        path="/quote/print"
        render={(props) => <QuotePrint {...props} />}
      />
      <Route
        path="/article/read"
        render={(props) => <ArticlePublicPage {...props} />}
      />
      <PrivateRoute
        path="/invoice/create"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/invoice/:id/create" // id: TicketId or ProjectId
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/invoice/export/:id"
        component={PDFPage}
        layout={PlainLayout}
      />
      <Route path="/payInvoice" render={(props) => <PayInvoice {...props} />} />
      <Route
        path="/tvView/:viewtype/:id/:type/"
        render={(props) => (
          <PageLayout
            {...props}
            routeComponent={<TvDashboardView {...props} />}
          />
        )}
      />
      <Route
        path="/invoice/print"
        render={(props) => <InvoicePrint {...props} />}
      />
      <Route
        path="/invoice"
        render={(props) => <InvoiceTemplate {...props} />}
      />
      <Route path="/quote" render={(props) => <QuoteTemplate {...props} />} />
      <Route
        path="/approval"
        render={(props) => <ApprovalTemplate {...props} />}
      />
      <PublicRoute
        path="/signup"
        component={SignupPageComponent}
        layout={PageLayout}
      />
      <PublicRoute
        path="/vendorlogin"
        component={VendorLoginPageComponent}
        layout={PageLayout}
      />
      <PublicRoute
        path="/confirmemail"
        component={ConfirmPage}
        layout={PageLayout}
      />
      <PublicRoute
        path="/forgotpassword"
        component={ForgotPasswordPageComponent}
        layout={PageLayout}
      />
      <Route
        path="/createnewpassword"
        render={(props) => (
          <PageLayout
            {...props}
            routeComponent={<CreateNewPasswordPageComponent {...props} />}
          />
        )}
      />
      <PublicRoute
        path="/resetpassword"
        component={ResetPasswordPageComponent}
        layout={PageLayout}
      />
      <PublicRoute
        path="/tfa"
        component={TFAPageComponent}
        layout={PageLayout}
      />
      <Route
        path="/minify/:module/:conversationtype/:typeid/:id"
        // component={ConversationTemplate}
        render={() => <ConversationTemplate />}
        // layout={PageLayout}
      />
      <Route
        path="/error"
        render={(allProps) => <ErrorPages {...allProps} />}
      />
      <PrivateRoute
        path="/pagenotfound"
        component={() => (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/PageNotFound.svg)`}
            text="Page Not Found"
            description="Built for a great technician experience and a greater IT service delivery experience"
          />
        )}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/configurenewtfa"
        component={TFAContainer}
        layout={PageLayout}
      />
      <PrivateRoute
        path="/updatenewpassword"
        component={UpdatePasswordPageComponent}
        layout={PageLayout}
      />
      <PrivateRoute
        path="/updatepassword"
        component={UpdatePasswordPageComponent}
        layout={PageLayout}
      />
      <PrivateRoute
        path="/configuretfa"
        component={TFAConfigPageComponent}
        layout={PageLayout}
      />
      <PrivateRoute
        path="/buyplans"
        component={NewPricingPage}
        layout={PageLayout}
      />
      <PrivateRoute
        path="/pricing"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/allmodules"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/createNew"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/home"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/productonboard"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/export/:pagename/:id"
        component={ExportsPage}
        layout={PlainLayout}
      />
      <PrivateRoute
        path="/mail/create"
        component={accountType === 'CLIENT' ? ClientHomePage : AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/serviceCatalog/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/contractTemplate/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/onboardingtemplates/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/ticketingtemplates/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/tasktemplates/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/clienttemplates/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/chattemplate/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/reply/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/projecttemplate/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/tasktemplate/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/formbuilder/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/soplist/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/sla/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/eventtrigger/:id/:type/:group/:ruleId"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/eventtrigger/:id/:type/:group/"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/timetrigger/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/ticketscheduler/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/mdm-client-setup/:id"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/clientportal"
        component={ClientHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/sites/:id/:siteid/:type"
        component={accountType === 'CLIENT' ? ClientHomePage : AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/fields/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/roles/:pagename/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/techniciangroup/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/holidays/:id/:type/:year"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/holidays/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/employee/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/marketplace/integrations/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/integrations/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/policymgmt/create/:classId"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/policymgmt/edit/:id/:category"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/policymgmt-new/edit/:id/:category"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/credential"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/asset-automation"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/non-monitored-asset/create"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/custom-network-assets/create"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/unmonitored-asset/create"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/non-monitored-asset/update/:id"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/unmonitored-asset/update/:id"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/softwarebundle/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/clientuser/:accountId/:id/:type"
        component={accountType === 'CLIENT' ? ClientHomePage : AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/non-monitored-asset-form/create"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/quotesettings/:id/:templateId"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/invoicesettings/:id/:templateId"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/invoiceTemplate/:templateId/:mode"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/non-monitored-asset-form/create"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/rmm/alert/:id/:mode"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/rmm/scripts-library/:type/:id/detail"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/rmm/scripts-library/:type/:id"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/rmm/scripts-library/:type/:id/view"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/rmm/patch/:id/:mode"
        component={AppHomePage}
        layout={ApplicationLayout}
      />

      <PrivateRoute
        path="/rmm/advance-policy-rule"
        component={AppHomePage}
        layout={ApplicationLayout}
      />

      <PrivateRoute
        path="/rmm/asset-group/:id/:mode"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/rmm/asset-view/:id/:mode"
        component={AppHomePage}
        layout={ApplicationLayout}
      />

      <PrivateRoute
        path="/client-home/:id"
        component={ClientHomePage}
        layout={ApplicationLayout}
      />

      <PrivateRoute
        path="/client-home"
        component={ClientHomePage}
        layout={ApplicationLayout}
      />

      <PrivateRoute
        path="/agent/marketplace/:id/:name/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/agent/marketplace/:category"
        component={AppHomePage}
        layout={ApplicationLayout}
      />

      <PrivateRoute
        path="/agent/marketplace"
        component={AppHomePage}
        layout={ApplicationLayout}
      />

      <PrivateRoute
        path="/rmm/network-view/:id/:mode"
        component={AppHomePage}
        layout={ApplicationLayout}
      />

      <PrivateRoute
        path="/rmm/network-graph"
        component={AppHomePage}
        layout={ApplicationLayout}
      />

      <PrivateRoute
        path="/rmm/asset/details/:id"
        component={accountType === 'CLIENT' ? ClientHomePage : AppHomePage}
        layout={ApplicationLayout}
      />

      <PrivateRoute
        path="/rmm/details/asset/:id/:classId"
        component={accountType === 'CLIENT' ? ClientHomePage : AppHomePage}
        layout={ApplicationLayout}
      />

      <PrivateRoute
        path="/rmm/remoteterminal/:assetId/:uniqueId/:loginType/:termType"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/rmm/asset/:entityName/:classId/:assetId/:mode"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/rmm/non-monitored-asset/details/:entityName/:classId/:assetId"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/rmm/:section/:tab/create"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/rmm/:section/:tab/detail"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/rmm/:section/:tab/"
        component={AppHomePage}
        layout={ApplicationLayout}
      />

      <PrivateRoute
        path="/kb/article/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/client/rmm/:section/:tab"
        component={ClientHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/alertTemplate/:id/:type"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/alert-ticket-template/edit/:id"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/itsm/insights/:type/:id/:section/:tab"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/itsm/insights/:type/:id?"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <Route path="/externalsharedreport/:id" render={() => <SharedReport />} />
      <PrivateRoute
        path="/:viewtype/:id/:pagename/:section/:sectionId/:name"
        component={accountType === 'CLIENT' ? ClientHomePage : AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/:viewtype/:id/:pagename/:section/:sectionId"
        component={accountType === 'CLIENT' ? ClientHomePage : AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/:viewtype/:id/:pagename/:type"
        component={accountType === 'CLIENT' ? ClientHomePage : AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/:viewtype/:id/:pagename"
        component={accountType === 'CLIENT' ? ClientHomePage : AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/:viewtype/:id/:pagename/taskView"
        component={TaskViewPage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/actions/ticket/view/:type/:id"
        component={ViewIndexPage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/onboard/:pagename"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/clientSettings/:clientId/invoicesettings/:id"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/:urlnotfound"
        component={AppHomePage}
        layout={ApplicationLayout}
      />
      <PrivateRoute
        path="/:somepage"
        component={() => (
          <ErrorPage
            imageURL={`url(${envConfig.imageRoot}svg/PageNotFound.svg)`}
            text="Page Not Found"
            description="Built for a great technician experience and a greater IT service delivery experience"
          />
        )}
        layout={ApplicationLayout}
      />
      <Redirect
        to={{
          pathname: '/login',
          from: '/',
          search: sessionStorage.getItem('redirectUrlParams')
        }}
      />
    </Switch>
  );
});
export default App;
